import React, { useState } from "react";
import "../InsightMenu/InsightPreview.scss";
import ResponseRate from '../../../assets/images/res-rate.png';

/* ---------- Dummy Data ---------- */
const DATA = {
    Gender: {
        Male: {
            responses: 34,
            participants: 34,
            percentage: 100,
            Location: {
                Mumbai: { responses: 32, participants: 32, percentage: 100 },
                Nagpur: { responses: 2, participants: 2, percentage: 100 }
            }
        },
        Female: {
            responses: 92,
            participants: 215,
            percentage: 42.79,
            Location: {
                Mumbai: { responses: 40, participants: 71, percentage: 56.34 },
                Pune: { responses: 35, participants: 71, percentage: 49.3 },
                Nagpur: { responses: 17, participants: 73, percentage: 23.29 }
            }
        }
    }
};

const IDENTIFIER_OPTIONS = ["Gender", "Location"];

const ResponseRatePreview = () => {
    const [identifiers, setIdentifiers] = useState(["Gender", "Location"]);
    const [expanded, setExpanded] = useState({});

    const toggle = key => {
        setExpanded(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const renderTree = () => {
        // 1. Safety check: If identifiers is empty or the first identifier isn't in DATA
        if (identifiers.length === 0 || !DATA[identifiers[0]]) {
            return (
                <div className="tree-row parent">
                    <div className="tree-label">ALL</div>
                    <div className="tree-metrics">
                        <div className="stat">126</div>
                        <div className="stat">249</div>
                        <div className="stat dark">50.6</div>
                    </div>
                </div>
            );
        }

        const [first, second] = identifiers;
        const dataSource = DATA[first];

        // 2. Double check dataSource is an object before calling entries
        return Object.entries(dataSource || {}).map(([key, value]) => (
            <div key={key}>
                {/* Parent Row */}
                <div className="tree-row parent">
                    <div className="tree-label" onClick={() => toggle(key)} style={{ cursor: 'pointer' }}>
                        <span className="toggle">{expanded[key] ? "−" : "+"}</span>
                        {key}
                    </div>

                    <div className="tree-metrics">
                        <div className="stat">{value.responses}</div>
                        <div className="stat">{value.participants}</div>
                        <div className="stat dark">{value.percentage}%</div>
                    </div>
                </div>

                {/* Children Rows */}
                {expanded[key] &&
                    second &&
                    value[second] &&
                    typeof value[second] === 'object' && // Ensure children exist
                    Object.entries(value[second]).map(([childKey, childVal]) => (
                        <div className="tree-row child" key={childKey}>
                            <div className="tree-label">
                                <span className="line" />
                                {childKey}
                            </div>

                            <div className="tree-metrics">
                                <div className="stat">{childVal.responses}</div>
                                <div className="stat">{childVal.participants}</div>
                                <div className="stat dark">{childVal.percentage}%</div>
                            </div>
                        </div>
                    ))}
            </div>
        ));
    };

    return (
        <div className="response-rate-preview">
            <img alt="" src={ResponseRate} className="preview-img w-100" />
            {/* 🔹 HEADER */}
            {/* <div className="response-header">
                <h5>Demography Wise Response</h5>

                <div className="response-controls">
                    <div className="identifier">
                        <label>Identifier</label>
                        <select
                            multiple
                            value={identifiers}
                            onChange={e =>
                                setIdentifiers(
                                    Array.from(e.target.selectedOptions, o => o.value)
                                )
                            }
                        >
                            {IDENTIFIER_OPTIONS.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <button className="btn-download">Download Data</button>
                </div>
            </div> */}

            {/* 🔹 TREE TABLE */}
            {/* <div className="tree-table">

                <div className="tree-header">
                    <div />
                    <div className="tree-metrics">
                        <span>RESPONSES</span>
                        <span>PARTICIPANTS</span>
                        <span>PERCENTAGE</span>
                    </div>
                </div>

                {renderTree()}
            </div> */}
        </div>
    );
};

export default ResponseRatePreview;
